module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec.t === 'time') ? _c('el-time-picker', {
    attrs: {
      "name": _vm._name,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly,
      "disabled": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('el-date-picker', {
    attrs: {
      "name": _vm._name,
      "type": _vm.spec.t,
      "placeholder": _vm.spec.placeholder,
      "picker-options": {
        disabledDate: _vm.spec.disabledDate
      },
      "readonly": _vm._readonly,
      "disabled": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dc19ecc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-datetime.vue
// module id = 515
// module chunks = 55